(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desplegable-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.dcListo === "1") return;
    raiz.dataset.dcListo = "1";
    var soloUna = raiz.dataset.dcSoloUna === "true";
    raiz.querySelectorAll(".desplegable-custom-pregunta").forEach(function (boton) {
      boton.addEventListener("click", function () {
        var item = boton.closest(".desplegable-custom-item");
        var estabaAbierta = item.classList.contains("abierta");
        if (soloUna) {
          raiz.querySelectorAll(".desplegable-custom-item.abierta").forEach(function (el) {
            el.classList.remove("abierta");
            var b = el.querySelector(".desplegable-custom-pregunta");
            if (b) b.setAttribute("aria-expanded", "false");
          });
        }
        if (!estabaAbierta) {
          item.classList.add("abierta");
          boton.setAttribute("aria-expanded", "true");
        } else {
          item.classList.remove("abierta");
          boton.setAttribute("aria-expanded", "false");
        }
      });
    });
  }
  function iniciarTodo() {
    document.querySelectorAll(".desplegable-custom").forEach(iniciar);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciarTodo);
  } else {
    iniciarTodo();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var raiz = e.target.querySelector(".desplegable-custom");
    if (raiz) iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.fqListo === "1") return;
    raiz.dataset.fqListo = "1";
    var soloUna = raiz.dataset.fqSoloUna === "true";
    raiz.querySelectorAll(".faq-custom-pregunta").forEach(function (boton) {
      boton.addEventListener("click", function () {
        var item = boton.closest(".faq-custom-item");
        var estabaAbierta = item.classList.contains("abierta");
        if (soloUna) {
          raiz.querySelectorAll(".faq-custom-item.abierta").forEach(function (el) {
            el.classList.remove("abierta");
            var b = el.querySelector(".faq-custom-pregunta");
            if (b) b.setAttribute("aria-expanded", "false");
          });
        }
        if (!estabaAbierta) {
          item.classList.add("abierta");
          boton.setAttribute("aria-expanded", "true");
        } else {
          item.classList.remove("abierta");
          boton.setAttribute("aria-expanded", "false");
        }
      });
    });
  }
  function iniciarTodo() {
    document.querySelectorAll(".faq-custom").forEach(iniciar);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciarTodo);
  } else {
    iniciarTodo();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var raiz = e.target.querySelector(".faq-custom");
    if (raiz) iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linea-de-tiempos-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.ltcListo === "1") return;
    raiz.dataset.ltcListo = "1";
    var items = Array.prototype.slice.call(raiz.querySelectorAll(".linea-tiempos-item"));
    if (!items.length) return;
    var disparador = parseFloat(raiz.dataset.ltcTrigger || "45") / 100;
    var pendiente = false;
    function actualizar() {
      pendiente = false;
      var lineaActivacion = window.innerHeight * disparador;
      var indiceActivo = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].getBoundingClientRect().top <= lineaActivacion) {
          indiceActivo = i;
        }
      }
      items.forEach(function (el, i) {
        el.classList.toggle("activa", i === indiceActivo);
      });
    }
    function alMover() {
      if (!pendiente) {
        pendiente = true;
        requestAnimationFrame(actualizar);
      }
    }
    window.addEventListener("scroll", alMover, { passive: true });
    window.addEventListener("resize", alMover);
    actualizar();
  }
  function iniciarTodo() {
    document.querySelectorAll(".linea-tiempos").forEach(iniciar);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciarTodo);
  } else {
    iniciarTodo();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var raiz = e.target.querySelector(".linea-tiempos");
    if (raiz) iniciar(raiz);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
